import { DataTable } from "@/components/common/DataTable";
import { StatusBadge } from "@/components/common/StatusBadge";
import { ProgressBar } from "@/components/common/ProgressBar";
import { Button } from "@/components/ui/button";
import { Rocket } from "lucide-react";
import { launchBadge, priorityBadge, isOverdue, WORKSTREAM_COLOR } from "@/data/launchOptions";

export const MilestoneTable = ({ milestones, today, onOpen, onAdd }) => {
  const columns = [
    { key: "title", header: "Milestone", render: (m) => (
      <button onClick={(e) => { e.stopPropagation(); onOpen(m); }} data-testid={`open-milestone-${m.id}`} className="text-left font-semibold text-[#14245F] hover:text-[#E0A82E]">{m.title}</button>
    )},
    { key: "workstream", header: "Workstream", render: (m) => (
      <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#14245F]"><span className="h-2 w-2 rounded-full" style={{ backgroundColor: WORKSTREAM_COLOR[m.workstream] || "#94A3B8" }} />{m.workstream || "—"}</span>
    )},
    { key: "readiness_weight", header: "Wt", render: (m) => <span className="font-numeric text-sm font-bold text-[#5A6B8C]">{m.readiness_weight ?? 1}</span> },
    { key: "owner", header: "Owner" },
    { key: "status", header: "Status", render: (m) => <StatusBadge status={launchBadge(m.status)} label={m.status} /> },
    { key: "priority", header: "Priority", render: (m) => <StatusBadge status={priorityBadge(m.priority)} label={m.priority} /> },
    { key: "due_date", header: "Target date", render: (m) => <span className={isOverdue(m, today) ? "font-bold text-[#DC2626]" : ""}>{m.due_date || "—"}</span> },
    { key: "completion", header: "Completion", render: (m) => <div className="w-28"><ProgressBar value={m.status === "Complete" ? 100 : m.completion} showLabel /></div> },
    { key: "current_blocker", header: "Blocker", render: (m) => m.current_blocker ? <span className="line-clamp-1 max-w-[160px] text-xs font-medium text-[#C2410C]">{m.current_blocker}</span> : "—" },
  ];

  return (
    <DataTable
      testid="milestones-table"
      columns={columns}
      rows={milestones}
      onRowClick={onOpen}
      emptyIcon={Rocket}
      emptyTitle="No milestones found"
      emptyDescription="Adjust filters or add a launch milestone to begin tracking readiness."
      emptyActionLabel="Add milestone"
      onEmptyAction={onAdd}
    />
  );
};
